import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager } from 'services/oidcConfig';
import { useAppDispatch } from 'store/hooks';
import { clearUser } from 'store/slices/userSlice';
import cls from './auth-page.module.scss';

export const LogoutCallback = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    userManager
      .signoutRedirectCallback()
      .then(() => {
        dispatch(clearUser());
        navigate('/auth', { replace: true });
      })
      .catch(err => {
        console.error('OIDC logout callback error:', err);
        setError(err?.message || 'Logout callback failed');
      });
  }, [navigate, dispatch]);

  return (
    <div className={cls.authPage}>
      <div className={cls.content}>
        <div className={cls.header}>
          {error ? (
            <div>
              <h2>Logout Error</h2>
              <p style={{ color: '#c00' }}>{error}</p>
              <button onClick={() => navigate('/auth')}>
                Back to Auth Page
              </button>
            </div>
          ) : (
            <h2>Processing Logout...</h2>
          )}
        </div>
      </div>
      <div className={cls.bg}>
        <div className={cls.blue} />
        <div className={cls.pink} />
        <div className={cls.orange} />
      </div>
    </div>
  );
};
